import { API, BASE_URL } from '@/config'
import { getUser } from '@/core/auth'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

const url = API.BASE_URL + '/workerServiceHub'

const hubService = {
  connection: new HubConnectionBuilder()
    .withUrl(url,
      {
        accessTokenFactory: () => getUser().then((res) => res.access_token),
      })
    .configureLogging(LogLevel.Information)
    .build(),

  start() {
    console.log(
      'Starting Hub...'
    )
    this.connection.start()
      .then(() => {
        console.log('Hub Started Successfully!')
      })
      .catch((err) => {
        console.log(
          'Error Starting Hub :(' +
          err
        )
        new Promise((resolve, reject) =>
          setTimeout(
            () =>
              this.start()
                .then(resolve)
                .catch(reject),
            5000
          )
        )
      });
    return this
  },

  //Server events:

  //Anonymous server event actionable
  onEvent(name, action) {
    this.connection.off(name) //ensure event doesnt get subscribed more than one time
    this.connection.on(name, (...args) => {
      try {
        console.log(`Executing SignalR hub event: ${name}`)
        action(...args)
      }
      catch (e) {
        console.log(
          `Error executing event: ${name}` +
          e
        )
      }
    })
  },

  //Client events
  sendMessage(text) {
    this.connection
      .invoke('SendMessage', text)
      .catch((err) => {
        /* eslint-disable no-debugger, no-console */
        console.log(`Error on connection.invoke(): ${err.toString()}`)
      })
  }
}

hubService.connection.onclose(() => hubService.start())

export const serverEvents = Object.freeze({
  ReceiveQueueReportMessage: 'ReceiveQueueReportMessage'
})

export default hubService.start()

